// AUTO-GENERATED — DO NOT EDIT.
// Run `npx tsx design_system/scripts/build.ts` to regenerate from tokens.css.
// tokens.css is the canonical source of truth.
export const colors = {
  orange: {
    "50": "242 229 213",
    "100": "234 205 171",
    "200": "222 179 128",
    "300": "212 155 79",
    "400": "199 129 42",
    "500": "163 109 40",
    "600": "127 83 34",
    "700": "86 57 19",
    "800": "43 28 15",
  },
  red: {
    "50": "239 219 211",
    "100": "227 184 169",
    "200": "216 149 129",
    "300": "201 115 73",
    "400": "186 77 38",
    "500": "153 62 33",
    "600": "120 48 23",
    "700": "80 31 12",
    "800": "40 17 12",
  },
  bluegreen: {
    "50": "224 241 240",
    "100": "195 227 225",
    "200": "165 214 211",
    "300": "133 202 198",
    "400": "103 188 183",
    "500": "84 154 150",
    "600": "63 120 117",
    "700": "42 83 80",
    "800": "16 40 39",
  },
  green: {
    "50": "222 231 223",
    "100": "194 211 194",
    "200": "162 189 164",
    "300": "128 166 131",
    "400": "97 143 99",
    "500": "79 119 82",
    "600": "59 91 63",
    "700": "38 62 39",
    "800": "19 29 19",
  },
  olive: {
    "50": "226 228 214",
    "100": "197 201 173",
    "200": "168 174 132",
    "300": "139 147 92",
    "400": "110 120 51",
    "500": "89 98 42",
    "600": "69 74 31",
    "700": "46 50 22",
    "800": "26 27 15",
  },
  fog: "#f6f6f7",
  mist: "#ececee",
  silver: "#d6d6d9",
  stone: "#9a9a9e",
  graphite: "#3a3a3d",
  ink: "#141416",
  white: "#ffffff",
  black: "#000000",
}
export const semantic = {
  cream: "#faf8f5",
  bg: "#faf8f5",
  bgAlt: "#f6f6f7",
  bgSunken: "#ececee",
  bgInverse: "#141416",
  fg1: "#141416",
  fg2: "#3a3a3d",
  fg3: "#6b6b6f",
  fgMuted: "#9a9a9e",
  fgInverse: "#f6f6f7",
  border: "#e4e4e7",
  borderStrong: "#d6d6d9",
  borderInk: "#141416",
  brand: "rgb(103 188 183)",
  brandHover: "rgb(84 154 150)",
  brandPress: "rgb(63 120 117)",
  brandSoft: "rgb(195 227 225)",
  accentWarm: "rgb(199 129 42)",
  accentEnergy: "rgb(186 77 38)",
  accentNature: "rgb(97 143 99)",
  accentEarth: "rgb(110 120 51)",
  success: "rgb(79 119 82)",
  successBg: "rgb(222 231 223)",
  warning: "rgb(199 129 42)",
  warningBg: "rgb(242 229 213)",
  danger: "rgb(153 62 33)",
  dangerBg: "rgb(239 219 211)",
  info: "rgb(84 154 150)",
  infoBg: "rgb(224 241 240)",
  bgPage: "#faf8f5",
  bgSurface: "#ffffff",
  bgRaised: "#ececee",
}
export const type = {
  fontFamily: {
    sans: "\"Poppins\", ui-sans-serif, system-ui, -apple-system, \"Segoe UI\", Roboto, sans-serif",
    display: "\"Poppins\", ui-sans-serif, system-ui, sans-serif",
    mono: "ui-monospace, \"SF Mono\", Menlo, Consolas, monospace",
  },
  fontWeight: {
    thin: 100,
    light: 300,
    regular: 400,
    medium: 500,
    semibold: 600,
    bold: 700,
    extrabold: 800,
    black: 900,
  },
  fontSize: {
    display: "clamp(56px, 7vw, 96px)",
    h1: "clamp(40px, 4.5vw, 64px)",
    h2: "clamp(32px, 3.2vw, 44px)",
    h3: "clamp(24px, 2.2vw, 30px)",
    h4: "20px",
    bodyLg: "18px",
    body: "16px",
    bodySm: "14px",
    caption: "12px",
    eyebrow: "12px",
  },
  lineHeight: {
    tight: 1.05,
    snug: 1.2,
    normal: 1.5,
    relaxed: 1.65,
  },
  tracking: {
    tight: "-0.02em",
    snug: "-0.01em",
    normal: "0",
    wide: "0.04em",
    eyebrow: "0.14em",
  },
}
export const spacing = {
  "1": "4px",
  "2": "8px",
  "3": "12px",
  "4": "16px",
  "5": "20px",
  "6": "24px",
  "8": "32px",
  "10": "40px",
  "12": "48px",
  "16": "64px",
  "24": "96px",
}
export const radius = {
  sm: "4px",
  md: "8px",
  lg: "12px",
  xl: "16px",
  "2xl": "20px",
  full: "9999px",
}
export const motion = {
  micro: "75ms",
  short: "150ms",
  medium: "250ms",
  long: "350ms",
}
export const cssVars = {
  "--fk-orange-50": "242 229 213",
  "--fk-orange-100": "234 205 171",
  "--fk-orange-200": "222 179 128",
  "--fk-orange-300": "212 155 79",
  "--fk-orange-400": "199 129 42",
  "--fk-orange-500": "163 109 40",
  "--fk-orange-600": "127 83 34",
  "--fk-orange-700": "86 57 19",
  "--fk-orange-800": "43 28 15",
  "--fk-red-50": "239 219 211",
  "--fk-red-100": "227 184 169",
  "--fk-red-200": "216 149 129",
  "--fk-red-300": "201 115 73",
  "--fk-red-400": "186 77 38",
  "--fk-red-500": "153 62 33",
  "--fk-red-600": "120 48 23",
  "--fk-red-700": "80 31 12",
  "--fk-red-800": "40 17 12",
  "--fk-bluegreen-50": "224 241 240",
  "--fk-bluegreen-100": "195 227 225",
  "--fk-bluegreen-200": "165 214 211",
  "--fk-bluegreen-300": "133 202 198",
  "--fk-bluegreen-400": "103 188 183",
  "--fk-bluegreen-500": "84 154 150",
  "--fk-bluegreen-600": "63 120 117",
  "--fk-bluegreen-700": "42 83 80",
  "--fk-bluegreen-800": "16 40 39",
  "--fk-green-50": "222 231 223",
  "--fk-green-100": "194 211 194",
  "--fk-green-200": "162 189 164",
  "--fk-green-300": "128 166 131",
  "--fk-green-400": "97 143 99",
  "--fk-green-500": "79 119 82",
  "--fk-green-600": "59 91 63",
  "--fk-green-700": "38 62 39",
  "--fk-green-800": "19 29 19",
  "--fk-olive-50": "226 228 214",
  "--fk-olive-100": "197 201 173",
  "--fk-olive-200": "168 174 132",
  "--fk-olive-300": "139 147 92",
  "--fk-olive-400": "110 120 51",
  "--fk-olive-500": "89 98 42",
  "--fk-olive-600": "69 74 31",
  "--fk-olive-700": "46 50 22",
  "--fk-olive-800": "26 27 15",
  "--fk-cream": "#faf8f5",
  "--fk-fog": "#f6f6f7",
  "--fk-mist": "#ececee",
  "--fk-silver": "#d6d6d9",
  "--fk-stone": "#9a9a9e",
  "--fk-graphite": "#3a3a3d",
  "--fk-ink": "#141416",
  "--fk-white": "#ffffff",
  "--fk-black": "#000000",
  "--fk-bg": "var(--fk-cream)",
  "--fk-bg-alt": "var(--fk-fog)",
  "--fk-bg-sunken": "var(--fk-mist)",
  "--fk-bg-inverse": "var(--fk-ink)",
  "--fk-fg1": "var(--fk-ink)",
  "--fk-fg2": "var(--fk-graphite)",
  "--fk-fg3": "#6b6b6f",
  "--fk-fg-muted": "var(--fk-stone)",
  "--fk-fg-inverse": "var(--fk-fog)",
  "--fk-border": "#e4e4e7",
  "--fk-border-strong": "var(--fk-silver)",
  "--fk-border-ink": "var(--fk-ink)",
  "--fk-brand": "rgb(var(--fk-bluegreen-400))",
  "--fk-brand-hover": "rgb(var(--fk-bluegreen-500))",
  "--fk-brand-press": "rgb(var(--fk-bluegreen-600))",
  "--fk-brand-soft": "rgb(var(--fk-bluegreen-100))",
  "--fk-accent-warm": "rgb(var(--fk-orange-400))",
  "--fk-accent-energy": "rgb(var(--fk-red-400))",
  "--fk-accent-nature": "rgb(var(--fk-green-400))",
  "--fk-accent-earth": "rgb(var(--fk-olive-400))",
  "--fk-success": "rgb(var(--fk-green-500))",
  "--fk-success-bg": "rgb(var(--fk-green-50))",
  "--fk-warning": "rgb(var(--fk-orange-400))",
  "--fk-warning-bg": "rgb(var(--fk-orange-50))",
  "--fk-danger": "rgb(var(--fk-red-500))",
  "--fk-danger-bg": "rgb(var(--fk-red-50))",
  "--fk-info": "rgb(var(--fk-bluegreen-500))",
  "--fk-info-bg": "rgb(var(--fk-bluegreen-50))",
  "--fk-font-sans": "\"Poppins\", ui-sans-serif, system-ui, -apple-system, \"Segoe UI\", Roboto, sans-serif",
  "--fk-font-display": "\"Poppins\", ui-sans-serif, system-ui, sans-serif",
  "--fk-font-mono": "ui-monospace, \"SF Mono\", Menlo, Consolas, monospace",
  "--fk-fw-thin": "100",
  "--fk-fw-light": "300",
  "--fk-fw-regular": "400",
  "--fk-fw-medium": "500",
  "--fk-fw-semibold": "600",
  "--fk-fw-bold": "700",
  "--fk-fw-extrabold": "800",
  "--fk-fw-black": "900",
  "--fk-fs-display": "clamp(56px, 7vw, 96px)",
  "--fk-fs-h1": "clamp(40px, 4.5vw, 64px)",
  "--fk-fs-h2": "clamp(32px, 3.2vw, 44px)",
  "--fk-fs-h3": "clamp(24px, 2.2vw, 30px)",
  "--fk-fs-h4": "20px",
  "--fk-fs-body-lg": "18px",
  "--fk-fs-body": "16px",
  "--fk-fs-body-sm": "14px",
  "--fk-fs-caption": "12px",
  "--fk-fs-eyebrow": "12px",
  "--fk-lh-tight": "1.05",
  "--fk-lh-snug": "1.2",
  "--fk-lh-normal": "1.5",
  "--fk-lh-relaxed": "1.65",
  "--fk-tracking-tight": "-0.02em",
  "--fk-tracking-snug": "-0.01em",
  "--fk-tracking-normal": "0",
  "--fk-tracking-wide": "0.04em",
  "--fk-tracking-eyebrow": "0.14em",
  "--fk-sp-1": "4px",
  "--fk-sp-2": "8px",
  "--fk-sp-3": "12px",
  "--fk-sp-4": "16px",
  "--fk-sp-5": "20px",
  "--fk-sp-6": "24px",
  "--fk-sp-8": "32px",
  "--fk-sp-10": "40px",
  "--fk-sp-12": "48px",
  "--fk-sp-16": "64px",
  "--fk-sp-24": "96px",
  "--fk-r-sm": "4px",
  "--fk-r-md": "8px",
  "--fk-r-lg": "12px",
  "--fk-r-xl": "16px",
  "--fk-r-2xl": "20px",
  "--fk-r-full": "9999px",
  "--fk-dur-micro": "75ms",
  "--fk-dur-short": "150ms",
  "--fk-dur-medium": "250ms",
  "--fk-dur-long": "350ms",
  "--fk-bg-page": "var(--fk-cream)",
  "--fk-bg-surface": "var(--fk-white)",
  "--fk-bg-raised": "var(--fk-mist)",
}
export const darkVars = {
  "--fk-bg-page": "#000000",
}
export const fontFaces = [
  {
    fontFamily: "\"Poppins\"",
    src: "url(\"/fonts/poppins-latin-300-normal.woff2\") format(\"woff2\")",
    fontWeight: "300",
    fontStyle: "normal",
    fontDisplay: "swap",
  },
  {
    fontFamily: "\"Poppins\"",
    src: "url(\"/fonts/poppins-latin-400-normal.woff2\") format(\"woff2\")",
    fontWeight: "400",
    fontStyle: "normal",
    fontDisplay: "swap",
  },
  {
    fontFamily: "\"Poppins\"",
    src: "url(\"/fonts/poppins-latin-400-italic.woff2\") format(\"woff2\")",
    fontWeight: "400",
    fontStyle: "italic",
    fontDisplay: "swap",
  },
  {
    fontFamily: "\"Poppins\"",
    src: "url(\"/fonts/poppins-latin-500-normal.woff2\") format(\"woff2\")",
    fontWeight: "500",
    fontStyle: "normal",
    fontDisplay: "swap",
  },
  {
    fontFamily: "\"Poppins\"",
    src: "url(\"/fonts/poppins-latin-600-normal.woff2\") format(\"woff2\")",
    fontWeight: "600",
    fontStyle: "normal",
    fontDisplay: "swap",
  },
  {
    fontFamily: "\"Poppins\"",
    src: "url(\"/fonts/poppins-latin-700-normal.woff2\") format(\"woff2\")",
    fontWeight: "700",
    fontStyle: "normal",
    fontDisplay: "swap",
  },
  {
    fontFamily: "\"Poppins\"",
    src: "url(\"/fonts/poppins-latin-700-italic.woff2\") format(\"woff2\")",
    fontWeight: "700",
    fontStyle: "italic",
    fontDisplay: "swap",
  }
]
export const tokens = { colors, semantic, type, spacing, radius, motion, cssVars, darkVars, fontFaces }
